import { Input, Label } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { MedicationResponse } from "@tellescope/types-models";

export interface CanvasMedicationInstructionsProps {
  medication: MedicationResponse;
  onChange: (medication: MedicationResponse) => void;
  fieldId?: string;
}

export const CanvasMedicationInstructions = ({ medication, onChange, fieldId }: CanvasMedicationInstructionsProps) => {
  const { t } = useTranslation("forms");
  const inputId = fieldId ? `${fieldId}-instructions` : undefined;

  return (
    <div className="space-y-1">
      <Label htmlFor={inputId}>{t("Medication instructions: how much you take, how often, and when")}</Label>
      <Input
        id={inputId}
        value={medication.dosage?.description ?? ""}
        onChange={(e) =>
          onChange({
            ...medication,
            dosage: {
              ...medication.dosage,
              description: e.target.value,
              value: medication.dosage?.value ?? "",
              unit: medication.dosage?.unit ?? "",
            },
          })
        }
      />
    </div>
  );
};
